module.exports = __webpack_public_path__ + "254db2539db1244e0670340293abab88.png";